import { Component, ViewEncapsulation } from '@angular/core';
import { ConfirmPopup, ConfirmPopupStyle } from 'primeng/confirmpopup';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss'],
  imports: [
    CommonModule,
    ButtonModule,
  ],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('animation', [
      state(
        'void',
        style({
          transform: 'scaleY(0.8)',
          opacity: 0
        })
      ),
      state(
        'open',
        style({
          transform: 'translateY(0)',
          opacity: 1
        })
      ),
      transition('void => open', animate('{{showTransitionParams}}')),
      transition('open => void', animate('{{hideTransitionParams}}'))
    ])
  ],
  providers: [ConfirmPopupStyle],
  host: {
    class: 'p-element'
  }
})
export class ConfirmPopupComponent extends ConfirmPopup {
}
